<template>
	<div style="position: fixed; left: 100%; top: 0;">
		<input ref="file" type="file" :accept="accept" :multiple="multiple" @change="uploadHandle" />
	</div>
</template>

<script>
	import ossUpload from '@/assets/script/lib/oss/upload'
	
	export default {
		data() {
			return {
				type: 'video,image,office,rar',
				multiple: false
			}
		},
		
		computed: {
			accept() {
				if (this.type) {
            return Array.from(this.type.split(','), item => {
              if (item == 'video') {
                  return '.swf,.flv,.mp3,.wav,.wma,.wmv,.mid,.avi,.mpg,.asf,.rm,.rmvb,.mp4,.mkv';
              } else if (item == 'image') {
                  return '.jpg,.png,.gif,.jpeg';
              } else if (item == 'office') {
                  return '.doc,.docx,.xls,.xlsx,.ppt,.txt,.pdf,.csv';
              } else if (item == 'rar') {
                  return '.rar,.tar,.zip,.7z';
              }
            }).join(',')
				}
				return '';
			}
		},
		
		methods: {
			upload(opt) {
				this.type = opt.fileType;
				this.multiple = !!opt.multiple;
				this._opt = opt;
				this.$nextTick(() => {
					this.$refs.file.click();
				});
			},
			
			uploadHandle(e) {
				ossUpload(e, {
					message: this._opt.message,
					multiple: this.multiple,
					fileType: this.accept.replace(new RegExp('.','g'), ''),
					fileSize: '300',   //上传文件最大支持300M
					success: data => {
						this.$refs.file.value = '';
						this._opt.success(data);
					}
				});
			}
		}
	};
</script>
